module.exports = __webpack_public_path__ + "static/media/Nogueira-florida-textura.06eff39b.png";